import { IsDebug } from 'domain/utils/domainUtil';
import * as S from './styles'
import { Icon } from '@iconify/react';


export function InDev(){

    return (
    IsDebug() &&
    <S.InDev className="fullCenter">
        <S.Label>
            <S.Text>Recurso em Desenvolvimento!</S.Text>
            <S.IconWrapper>
            <Icon icon="ic:outline-logo-dev" height="50px" />
            </S.IconWrapper>
          
        </S.Label>
    </S.InDev>

    )
}
